import apiService from "../common/commonApi";

export const leaveOverview = {};

leaveOverview.getListOverview = async (param) => {
    return apiService.Get("getLeaveOverview", param);
};

leaveOverview.updateOverview = async (param) => {
    return apiService.Post("updateOtherLeave", param);
};
